import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';

const Maintenance = () => {
  return (
    <div className="page_wrapper flex maintenance-page">
      <div className="m-auto flex justify-center text-4xl">
        <div className="float-left">
          <Icon
            id="close"
            width="26.43"
            height="26.43"
            className="p-1 rounded-full bg-red-500 text-white mr-8 mt-1"
            role="presentation"
            accessibility={{ ariaHidden: true }}
          />
        </div>
        <div className="float-right leading-relaxed">
          <div className="font-medium">
            AP Classroom and Pre-AP Classroom Maintenance
          </div>
          <p className="leading-normal text-3xl max-w-3xl">
            AP Classroom and Pre-AP Classroom are currently undergoing scheduled
            maintenance. This is scheduled to be completed by Sunday, 11/12/2023
            5:00 PM ET, but may be completed sooner. We apologize for the
            inconvenience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
